module.exports = __webpack_public_path__ + "static/img/transport.fe71962e.png";